import { functions } from '../../../config/firebase'
import { getCallableErrorMessage } from '../../ProductsSyncMenu/syncDateUtils'
import { buildGiftWithPurchaseSavePayload } from './mapGiftWithPurchaseConfig'
import { mapGiftWithPurchaseConfigFromDoc } from './mapGiftWithPurchaseConfig'

const saveGiftWithPurchaseConfig = async (draft) => {
  try {
    const callable = functions.httpsCallable('saveGiftWithPurchaseConfig')
    const result = await callable(buildGiftWithPurchaseSavePayload(draft))
    const config = mapGiftWithPurchaseConfigFromDoc(result?.data?.config || result?.data)

    return {
      ok: true,
      config,
    }
  } catch (error) {
    console.error('[saveGiftWithPurchaseConfig] failed:', error)

    return {
      ok: false,
      message: getCallableErrorMessage(error),
    }
  }
}

export default saveGiftWithPurchaseConfig
